import { Component, input, output, signal } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";

@Component({
    selector: "app-dialog",
    imports: [ButtonModule, DialogModule],
    templateUrl: "./dialog.component.html",
    styleUrl: "./dialog.component.scss"
})
export class DialogComponent {
	dialogId = input<string>("");
	dialogHeader = input<string>($localize`:@@dialog.default.header:Dialog`);
	title = input<string>("");
	content = input<string>("");
	btnName = input<string>("");
	type = input<string>("");
	cancelBttnText = input<string | undefined>("");
	onSuccess = output<string>();
	isShowDialog = signal<boolean>(false);

	// all Dialog control here
	showDialog() {
		this.isShowDialog.set(true);
	}

	closeDialog() {
		this.isShowDialog.set(false);
	}

	confirmDialog() {
		this.onSuccess.emit(this.type());
	}
}
